import type { FaireProductEntity } from "../../entity_types/product";

export const p_x573mrjtxu: FaireProductEntity = {
  token: "p_x573mrjtxu",
  type: "product",
  name: "Guava Mango Smoothie Advanced Smoothing Lip Treatment",
  brandToken: "b_8oy7a20lz0",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/563649eb2ba5018c7ca07b9459c116712b11354e38d7f12e4fd7c1f2852ac350.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7279a50484c577e8fd508f21e7c63e2243dd4d6ca3649253c0250fa1da8fdfd.jpeg",
    "https://cdn.faire.com/fastly/49bf0bae080a933ae5e88f0a3fcffbe127c48fda6614ba33eb284f80dd25764f.jpeg",
    "https://cdn.faire.com/fastly/dd943ed00a10cf763e859b49d36109b1b7acc19fae51353ec1391c419ddb6cce.jpeg",
    "https://cdn.faire.com/fastly/d044ee6dc61e532cf3908bc9611c6b6b593dd9d8cd971d63f7738fe39f62af24.jpeg",
    "https://cdn.faire.com/fastly/24a186d5f87c2127cf9f72c1881573a2a655848daf5db72c272cb4c8e2782773.png",
    "https://cdn.faire.com/fastly/96c501ad48a1c6d1388a232369d77765a81833de93f657cf8f0fe81dfca90c5f.jpeg",
    "https://cdn.faire.com/fastly/a207c489cf95b5c60f8efd6c763cd02d2a8777300d058070736e705f536ec576.jpeg",
    "https://cdn.faire.com/fastly/84be55db47f5b475358c106256ae42291b5eb7d81331ca3b4626cc36c5ad5f86.jpeg",
  ],
  priceDollars: 6,
  description:
    "Our best-selling Guava Mango Smoothie Lip Treatment will visibly improve fine line, wrinkles & elasticity in your lips while providing a light pink tint. These ingredients, in combination with shea butter and peptides, help to remove dead skin cells and support fuller, smoother looking lips. \n\nKey Ingredient Highlight:\n\nShea Butter: Deeply nourishes and softens lips by locking in moisture and reinforcing the skin barrier, helping to relieve dryness and prevent moisture loss for smoother, healthier-looking lips.\n\nPeptides: Help support the lips’ natural repair and renewal processes, improving the look of smoothness and firmness while promoting healthier-looking, more conditioned lips over time.\n\n🫧 Clean Ingredients\n🌱 Vegan\n🫶 Cruelty-Free\n♻️ Sustainable\n🌎 Made in Korea (K-Beauty Inspired)\n\nA NOTE ON OUR REBRAND: As our updated packaging rolls out, you may receive our original or new designs. All products feature the same proven formulas customers love, while refreshed packaging puts skin benefits and key actives front and center to support clarity at the shelf and confident purchasing.\n\nIdeal for self-care, impulse buys, gifting, back-to-school, holidays, spas, boutiques, and combatting Fall/Winter dry skin.\n",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:35.785Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
